<template>
  <div class="company-info-page">
    <Headers />
    <!-- Hero Section -->
    <div class="hero-section">
      <div class="hero-overlay"></div>
      <div class="hero-content">
        <h1 class="hero-title">Company Information</h1>
        <p class="hero-description">K & I International Trade Inc.</p>
      </div>
    </div>

    <!-- Content Section -->
    <div class="content-section">
      <div class="content-container">
        <!-- Public Statement -->
        <h2 class="section-title">Public Statement</h2>
        <p class="date-text">January 26, 2022</p>

        <p class="text-paragraph">
          On January 26, 2022, we reached an agreement with Epson. GooDee will
          only use lumen to indicate the brightness of the projector in future.
        </p>
        <p class="text-paragraph">
          All projectors sold or manufactured by GooDee will display white
          brightness (hereinafter, "Brightness") in lumen utilizing an
          internationally recognized and published testing standard for
          projectors (the "Standard"), such as IDMS v. 1.03 (15.3) or ISO/IEC
          21118, both on the Products' packaging and advertisements.
        </p>
        <p class="text-paragraph">
          GooDee is committed to providing brightness specifications on its
          Products measured in accordance with internationally recognized and
          published testing standards to make it easier for customers to compare
          projectors.
        </p>

        <!-- Product Specifications -->
        <h2 class="section-title">Product Brightness Specifications</h2>
        <p class="text-paragraph">Current Model's Lux(L) convert to lumen:</p>

        <p
          class="text-paragraph"
          v-for="product in products"
          :key="product.model"
        >
          {{ product.model }}: {{ product.lux }} = {{ product.lumen }}
        </p>

        <!-- Company Info -->
        <p class="signature">Regards,</p>
        <p class="company-name">K & I International Trade Inc.</p>
      </div>
    </div>

    <!-- Footer -->
    <Footer />
  </div>
</template>

<script lang="js">
import Headers from '@/components/Headers.vue';
import Footer from '@/components/Footer.vue';
export default {
  name: "CompanyInfoPage",
  components: {
    Headers,
    Footer,
  },
  data() {
    return {
      products: [
        { model: "YG600", lux: "8500L", lumen: "500 lumen" },
        { model: "YG230", lux: "2500L", lumen: "150 lumen" },
        { model: "YG420", lux: "7500L", lumen: "440 lumen" },
        { model: "YG620", lux: "", lumen: "600 lumen" },
        { model: "W80", lux: "7000L", lumen: "400 lumen" },
        { model: "W18", lux: "", lumen: "400 lumen" },
        { model: "Bl98", lux: "9500L", lumen: "560 lumen" },
      ],
    };
  },
};
</script>

<style scoped>
/* Hero Section */
.hero-section {
  position: relative;
  height: 400px;
  background-image: url("http://img-for-hk.wds168.cn/comdata/6482285/201705/20170531164321265495.jpg");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hero-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
}

.hero-content {
  position: relative;
  z-index: 1;
  text-align: center;
  color: white;
}

.hero-title {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1rem;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.5);
}

.hero-description {
  font-size: 1.25rem;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.5);
}

/* Content Section */
.content-section {
  background: white;
  padding: 4rem 4rem;
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
}

.section-title {
  font-size: 1.75rem;
  font-weight: 600;
  color: #1a202c;
  margin-top: 3rem;
  margin-bottom: 1rem;
}

.section-title:first-child {
  margin-top: 0;
}

.date-text {
  color: #718096;
  font-size: 0.95rem;
  margin-bottom: 2rem;
}

.text-paragraph {
  color: #4a5568;
  line-height: 1.8;
  margin-bottom: 1.5rem;
  text-align: justify;
}

/* Signature */
.signature {
  color: #4a5568;
  margin-top: 3rem;
  margin-bottom: 0.5rem;
}

.company-name {
  font-size: 1.125rem;
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 3rem;
}

/* Mobile */
@media (max-width: 640px) {
  .hero-section {
    height: 300px;
  }

  .hero-title {
    font-size: 1.75rem;
  }

  .hero-description {
    font-size: 1rem;
  }

  .content-section {
    padding: 2rem 1.5rem;
  }

  .section-title {
    font-size: 1.5rem;
  }
}
</style>
